import { SUPPORTED_NETWORK } from '../constants'

interface ReferralCodeState {
  code: string
}

const REFERRAL_CODE_STORAGE_KEY = `@${SUPPORTED_NETWORK.OPTIMEX}-referral-code`

const DEFAULT_REFERRAL_CODE_STATE: ReferralCodeState = {
  code: '',
}

export const referralCodeStorage = {
  getState: (): ReferralCodeState => {
    try {
      const stored = localStorage.getItem(REFERRAL_CODE_STORAGE_KEY)
      if (!stored) return DEFAULT_REFERRAL_CODE_STATE
      return JSON.parse(stored) as ReferralCodeState
    } catch (error) {
      console.error('Error getting access method state:', error)
      return DEFAULT_REFERRAL_CODE_STATE
    }
  },

  save: (state: ReferralCodeState) => {
    localStorage.setItem(REFERRAL_CODE_STORAGE_KEY, JSON.stringify(state))
  },

  update: (payload: Partial<ReferralCodeState>) => {
    try {
      const currentState = referralCodeStorage.getState()
      referralCodeStorage.save({
        ...currentState,
        ...payload,
      })
    } catch (error) {
      console.error('Error updating access method:', error)
    }
  },

  remove: () => {
    localStorage.removeItem(REFERRAL_CODE_STORAGE_KEY)
  },
}
